// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3uLJV","sendOtp":"AuthorizeToLogin_sendOtp__3z_bV"};